import React from 'react';
import classNames from 'classnames';
import Button from '@components/Button';

interface Props {
  title?: string;
  className?: string;
  onClick: () => void;
}

function SidebarApplyTo({
  title = '把设置应用到…',
  className,
  onClick,
}: Props) {
  return (
    <Button
      scheme="dark"
      className={classNames('w-full', className)}
      onClick={onClick}
    >
      {title}
    </Button>
  );
}

export default SidebarApplyTo;
